/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */
'use strict';

const loginFactory = require('components/user_area/login/js/main');
const createWidgetLoader = require('components-framework/widget/create_widget_loader');
const widgetLoader = createWidgetLoader({
    login: ['login-header', loginFactory],
});

var trackingUtils = require('../utils/tracking.utils');

module.exports = {
    seatMapSelectionData: {seatMapSelectionRequests: [], numberOfRetries: 0},
    viewEvents: {
        'seatmap-selection-manager:updateSeatsInPassengersPage': 'updateSeatsInPassengersPage',
        'baggagesmanager:trackPrefillBaggages': 'trackPrefillAncillaries',
        'global:userLogout': 'onLogout',
        'seatmap:updateSeatsInPassengersPage': 'updateSeatsInPassengersPage',
    },
    eventHandlers: {
        onLogout() {
            widgetLoader.get('login').execute('logOutOk');
        },
        trackPrefillAncillaries: Odigeo._.once(function(data) {
            var seatSelection = Odigeo.Session.get('trackABSeatsInSession') ? '_seats' : '';
            var ancillaries = seatSelection + (data.saveBaggages ? '_baggage' : '');
            Odigeo.Session.remove('trackABSeatsInSession');
            if (ancillaries) {
                trackingUtils.trackEvent('on_load', 'ancillaries_preselected' + ancillaries);
            }
        }),
        updateSeatsInPassengersPage: function(data) {
            if (!Odigeo._.isEmpty(data)) {
                this.seatMapSelectionData = data.seatData;
            }
        },
        reloadNewBuyerPage() {
            Odigeo.requireWidget('buyer', 'passengers_manager', (buyer) => {
                if (!buyer.get('isBuyerTemplate')) {
                    Odigeo.Router.reload();
                }
            });
        },
    },
    isLandingFromMetaPassengers: function() {
        const mktPortal = (location.search.match(/mktportal=([a-zA-Z-]+)/) || [null, 'T'])[1];
        const landingPageType = (location.search.match(/landingPageType=([A-Z]+)/) || [null, null])[1];
        const isMetaForIntermediate = Odigeo.Session.get('isMetaForIntermediate');
        return landingPageType === 'PASSENGER' && mktPortal !== 'T' && !isMetaForIntermediate;
    },
};

